import styled from "styled-components";
import { IMAGES } from "../../../constants/images";

export default function BufferItem({ title, value, onPlus, onMinus, onDelete, onChange, disabled }) {
  return (
    <BufferItemContainer>
      <span>{title}</span>
      <BufferInput>
        <button onClick={onMinus}>-</button>
        <input type="number" value={value} step={1} onChange={onChange} />
        <button onClick={onPlus}>+</button>
      </BufferInput>
      <DeleteButton onClick={onDelete} disabled={disabled}>
        <img src={IMAGES.CLOSE} alt="Delete" />
      </DeleteButton>
    </BufferItemContainer>
  );
}

const BufferItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;

  span {
    width: 10%;
  }
`;

const BufferInput = styled.div`
  display: flex;
  align-items: center;
  width: 80%;
  background-color: white;
  border-radius: 5px;
  transition: background-color 0.3s;
  overflow: hidden;

  button {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
    height: 100%;
    width: 50px;
  }

  button:hover {
    background-color: #ececec;
  }

  input {
    all: unset;
    text-align: center;
    width: 100%;
    height: 24px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  &:has(input:focus) {
    outline: 2px solid #0f77ffff;
  }
`;

const DeleteButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 10%;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
